// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.ExportLandlordTransactionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ExportLandlordTransactionsRequestDto } from '../..';

export const ExportLandlordTransactionsWebApiHandler_exportLandlordTransactions_Path =
  '/api/web/v1/exportLandlordTransactions';

/**
 * Export aggregate view transactions as CSV
 */
export const ExportLandlordTransactionsWebApiHandler_exportLandlordTransactions = (
  postData: ExportLandlordTransactionsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ExportLandlordTransactionsRequestDto, void>(
    {
      endpoint: ExportLandlordTransactionsWebApiHandler_exportLandlordTransactions_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
